import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function AboutPage() {
  const [formSuccess, setFormSuccess] = useState(false);
  const [formError, setFormError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError('');
    setSubmitting(true);

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt') as string;

    if (honeypot && honeypot.trim() !== '') {
      setFormSuccess(true);
      setSubmitting(false);
      return;
    }

    formData.delete('phone_alt');

    try {
      const res = await fetch('https://readdy.ai/api/form/d9pmnbub4qjhggaeq1bg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as any).toString(),
      });
      const responseText = await res.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = {}; }

      if (res.ok && parsed?.code === 'OK') {
        setFormSuccess(true);
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
        setFormError(msg);
      }
    } catch {
      setFormError('网络错误，请稍后重试');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <main className="pt-20 bg-background-50">
        {/* Page Header */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
            <nav className="flex items-center justify-center gap-2 text-sm text-foreground-500 mb-6" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-900 font-medium">关于我们</span>
            </nav>
            <h1 className="text-2xl md:text-5xl font-bold font-heading text-foreground-950 mb-4">
              关于 aaa日韩
            </h1>
            <p className="text-sm md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              aaa日韩致力于为用户提供最优质的日韩正版内容，打造极致的在线观影体验
            </p>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
              <div>
                <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-5">
                  品牌介绍
                </h2>
                <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                  <p>
                    aaa日韩成立于2020年，是一家专注于日韩内容领域的正版流媒体平台。我们与日本、韩国多家顶级内容制作公司和发行商建立了深度合作关系，确保平台上的所有内容均为正版授权。
                  </p>
                  <p>
                    经过多年的发展，aaa日韩已经积累了超过<strong>5000部</strong>正版日韩资源，涵盖日剧、韩剧、动漫、综艺、电影、音乐等多元品类。平台注册用户已突破<strong>1000万</strong>，日均活跃用户超过200万。
                  </p>
                  <p>
                    我们的使命是让每一位日韩文化爱好者都能便捷地享受到高品质的正版内容。从内容引进、字幕制作到技术平台的搭建，aaa日韩始终坚持高标准、严要求，力求为用户提供极致的观影体验。
                  </p>
                </div>
              </div>
              <div className="relative aspect-square rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20office%20interior%20with%20warm%20lighting%2C%20minimalist%20design%2C%20clean%20workspace%2C%20Japanese%20Korean%20aesthetic%20fusion%2C%20professional%20atmosphere%2C%20cream%20and%20beige%20tones%2C%20soft%20natural%20light&width=600&height=600&seq=about-brand-01&orientation=squarish"
                  alt="aaa日韩品牌形象"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                品牌口碑
              </h2>
              <p className="text-sm md:text-base text-foreground-600">
                用户的认可，是我们前进的最大动力
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {[
                {
                  quote: 'aaa日韩的画质真的太棒了，4K看日剧完全是一种享受。而且更新速度很快，基本上日本播完第二天就能看到中文字幕版。',
                  author: '日剧爱好者 - 小林',
                  rating: 5,
                },
                {
                  quote: '用了aaa日韩半年多了，资源真的全。韩剧、综艺、动漫应有尽有，一个平台解决所有需求，再也不用到处找资源了。',
                  author: '韩综达人 - 小美',
                  rating: 5,
                },
                {
                  quote: '作为日漫迷，aaa日韩的动漫资源让我非常满意。正版授权、高清画质、专业字幕，这才是看动漫的正确打开方式。',
                  author: '动漫发烧友 - 阿强',
                  rating: 5,
                },
              ].map((review, idx) => (
                <div
                  key={idx}
                  className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70"
                >
                  <div className="flex items-center gap-1 mb-4">
                    {Array.from({ length: review.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    &ldquo;{review.quote}&rdquo;
                  </p>
                  <p className="text-xs text-foreground-500 font-medium">
                    — {review.author}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
              {/* Contact Info */}
              <div>
                <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-5">
                  联系我们
                </h2>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-1">电子邮箱</h3>
                      <p className="text-sm text-foreground-600">support@aaarihan.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-phone-line text-primary-600"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-1">客服电话</h3>
                      <p className="text-sm text-foreground-600">400-888-8888</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-time-line text-primary-600"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-1">服务时间</h3>
                      <p className="text-sm text-foreground-600">7×24小时在线客服</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-map-pin-line text-primary-600"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-1">公司地址</h3>
                      <p className="text-sm text-foreground-600">北京市朝阳区建国路88号SOHO现代城A座</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Form */}
              <div>
                <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-5">
                  在线留言
                </h2>
                <form
                  onSubmit={handleSubmit}
                  data-readdy-form="true"
                  className="space-y-4"
                >
                  <div>
                    <label htmlFor="about-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      姓名
                    </label>
                    <input
                      id="about-name"
                      name="name"
                      type="text"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="about-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      邮箱
                    </label>
                    <input
                      id="about-email"
                      name="email"
                      type="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="about-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      留言内容
                    </label>
                    <textarea
                      id="about-message"
                      name="message"
                      required
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all resize-none"
                      placeholder="请输入您的留言内容（500字以内）"
                    ></textarea>
                  </div>
                  {/* Honeypot */}
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <button
                    type="submit"
                    disabled={submitting}
                    className="w-full px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer disabled:opacity-60"
                  >
                    {submitting ? '提交中...' : '提交留言'}
                  </button>
                  {formSuccess && (
                    <p className="text-sm text-secondary-600 text-center">提交成功！我们会尽快与您联系。</p>
                  )}
                  {formError && (
                    <p className="text-sm text-red-500 text-center">{formError}</p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <ScrollToTop />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于我们 - aaa日韩',
            description: 'aaa日韩品牌介绍、口碑评价与联系方式',
            url: 'https://www.aaarihan.com/about',
            isPartOf: { '@id': 'https://www.aaarihan.com/#website' },
            about: {
              '@type': 'Organization',
              name: 'aaa日韩',
              description: 'aaa日韩是专注于日韩内容的正版流媒体平台',
              email: 'support@aaarihan.com',
              telephone: '400-888-8888',
              address: {
                '@type': 'PostalAddress',
                addressLocality: '北京',
                addressRegion: '朝阳区',
                streetAddress: '建国路88号SOHO现代城A座',
              },
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://www.aaarihan.com',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: '关于我们',
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}